import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const tiktokRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Tiktok" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { TiktokCallback } = await import("./callback");
          return { Component: TiktokCallback };
        },
      },
    ],
  },
];
